import { createTriggerUtils, ITriggerData, ITriggerShellData } from "../../../trigger/ITrigger.intf";
import { appNamespace } from "../app-namespace";
import { ulid } from "ulid";
import { UI } from "./UI";

const type = `${appNamespace}when-activity-in`

export interface ITriggerWhenActivityInJavaData{
    pn:string
    an:string
    cn?:string
}

export interface ITriggerWhenActivityInData extends ITriggerData<ITriggerShellData, ITriggerWhenActivityInJavaData>{
    
}

function createDefultData():ITriggerWhenActivityInData{
    return {
        id:ulid(),
        type,
        javaData:{
            pn:"",
            an:"",
            cn:""
        }
    }
}

function init(){
    
}   

export const triggerWhenActivityInUtils = createTriggerUtils<ITriggerWhenActivityInData>(type, init, createDefultData, UI)  